(function () {
  var root = document.querySelector('[data-spark-homepage]');
  if (!root || root.dataset.bound === '1') return;
  root.dataset.bound = '1';

  var configEl = root.querySelector('[data-spark-homepage-config]');
  var config = {};
  try {
    config = configEl ? JSON.parse(configEl.textContent || '{}') : {};
  } catch (err) {
    config = {};
  }

  var defaultPlans = {
    '3mo': {
      variant: 49436001763565,
      sellingPlan: '9595093229',
      label: '3 month Blys™ plan selected.',
      checkoutLabel: '$249 every 3 months',
      content: 'subscription_3mo',
      countLabel: '30 Count',
      galleryIndex: 1
    },
    '1mo': {
      variant: 49309993337069,
      sellingPlan: '9595027693',
      label: 'Monthly Blys™ plan selected.',
      checkoutLabel: '$99 monthly',
      content: 'subscription_1mo',
      countLabel: '10 Count',
      galleryIndex: 0
    },
    one: {
      variant: 50091543363821,
      sellingPlan: null,
      label: 'One time Blys™ purchase selected.',
      checkoutLabel: '$149 one-time',
      content: 'one_time',
      countLabel: '10 Count',
      galleryIndex: 0
    },
    one3: {
      variant: 49436001763565,
      sellingPlan: null,
      label: '3-pack one-time Blys™ purchase selected.',
      checkoutLabel: '$299 one-time 3-pack',
      content: 'one_time_3mo',
      countLabel: '30 Count',
      galleryIndex: 1
    }
  };
  var configuredPlans = config.plans || {};
  var plans = {};
  Object.keys(defaultPlans).forEach(function (key) {
    plans[key] = Object.assign({}, defaultPlans[key], configuredPlans[key] || {});
    if (!plans[key].variant) plans[key].variant = defaultPlans[key].variant;
    if (plans[key].sellingPlan === undefined || plans[key].sellingPlan === '') plans[key].sellingPlan = defaultPlans[key].sellingPlan;
    if (!plans[key].label) plans[key].label = defaultPlans[key].label;
    if (!plans[key].checkoutLabel) plans[key].checkoutLabel = defaultPlans[key].checkoutLabel;
    if (!plans[key].content) plans[key].content = defaultPlans[key].content;
  });
  Object.keys(configuredPlans).forEach(function (key) {
    if (!plans[key]) plans[key] = configuredPlans[key];
  });
  var selected = '3mo';
  var threePackAsset = 'amie-blys-three-pack-tm-v2.png';
  var status = root.querySelector('[data-spark-status]');
  var loading = root.querySelector('[data-spark-loading]');
  var campaign = config.campaign || root.getAttribute('data-spark-campaign') || 'spark_home_single_sku';
  var lander = config.lander || root.getAttribute('data-spark-lander') || 'spark_homepage_single_sku';
  var qualificationUrl = config.quizUrl || 'https://start.tryamie.com/start/spark';

  function currentPlan() {
    return plans[selected] || plans['3mo'] || {};
  }

  function currentPlanMode() {
    return selected === 'one' || selected === 'one3' ? 'one' : 'subscription';
  }

  function isThreePackPlan(plan) {
    return selected === '3mo' || selected === 'one3' || plan.content === 'subscription_3mo' || plan.content === 'one_time_3mo';
  }

  function threePackImageSrc(gallery) {
    var existing = gallery.querySelector('img[src*="' + threePackAsset + '"]');
    if (existing) return existing.getAttribute('src') || existing.currentSrc || existing.src || '';

    var productImage = gallery.querySelector('img[src*="amie-blys-pdp-"]');
    var src = productImage ? (productImage.getAttribute('src') || productImage.currentSrc || productImage.src || '') : '';
    var match = src.match(/^(.*\/assets\/)amie-blys-pdp-[^/?]+-v1\.jpg(?:\?.*)?$/);
    return match ? match[1] + threePackAsset : '';
  }

  function preferredGalleryIndex(gallery, plan, fallbackIndex) {
    if (!isThreePackPlan(plan)) return fallbackIndex;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.spark-pdp-gallery__slide'));
    var existingIndex = slides.findIndex(function (slide) {
      var image = slide.querySelector('img');
      return image && (image.getAttribute('src') || image.currentSrc || image.src || '').indexOf(threePackAsset) !== -1;
    });
    if (existingIndex !== -1) return existingIndex;

    var targetSlide = slides[fallbackIndex];
    var image = targetSlide ? targetSlide.querySelector('img') : null;
    var src = threePackImageSrc(gallery);
    if (!image || !src) return fallbackIndex;

    image.setAttribute('src', src);
    image.removeAttribute('srcset');
    image.setAttribute('alt', 'Three Blys™ rapid dissolve tablet packages');
    targetSlide.classList.remove('spark-pdp-gallery__slide--portrait', 'spark-pdp-gallery__slide--photo');
    targetSlide.classList.add('spark-pdp-gallery__slide--infographic');
    return fallbackIndex;
  }

  function updatePlanUi() {
    var plan = currentPlan();
    var mode = currentPlanMode();
    root.querySelectorAll('[data-spark-plan]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-spark-plan') === selected ? 'true' : 'false');
    });
    root.querySelectorAll('[data-spark-plan-mode]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-spark-plan-mode') === mode ? 'true' : 'false');
    });
    root.querySelectorAll('[data-spark-plan-group]').forEach(function (group) {
      var visible = group.getAttribute('data-spark-plan-group') === mode;
      group.hidden = !visible;
      group.setAttribute('aria-hidden', visible ? 'false' : 'true');
    });
    root.querySelectorAll('[data-spark-savings-badge]').forEach(function (badge) {
      badge.hidden = false;
      badge.textContent = mode === 'subscription' ? 'Save $50' : 'Save up to $148';
    });
    root.querySelectorAll('[data-spark-checkout-label]').forEach(function (label) {
      label.textContent = plan.checkoutLabel || plan.label || 'selected plan';
    });
    root.querySelectorAll('[data-spark-count-badge]').forEach(function (badge) {
      badge.textContent = plan.countLabel || '';
      badge.hidden = !plan.countLabel;
    });
    syncSelectedPlanGallery(plan);
    if (status) status.textContent = plan.label || 'Blys™ plan selected.';
  }

  function syncSelectedPlanGallery(plan) {
    var index = Number(plan.galleryIndex);
    if (!Number.isFinite(index)) return;
    root.querySelectorAll('[data-spark-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-spark-gallery-track]');
      var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-spark-gallery-dot]'));
      if (!track) return;
      index = preferredGalleryIndex(gallery, plan, Math.max(0, index));
      var width = Math.max(track.clientWidth || track.getBoundingClientRect().width || 0, 1);
      var left = index * width;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        track.scrollLeft = left;
      }
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    });
  }

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function qualify() {
    if (loading) loading.classList.add('is-active');
    window.location.assign(qualificationUrl);
  }

  root.addEventListener('click', function (event) {
    var planButton = closest(event.target, '[data-spark-plan]');
    if (planButton && root.contains(planButton)) {
      event.preventDefault();
      var planKey = planButton.getAttribute('data-spark-plan');
      selected = plans[planKey] ? planKey : '3mo';
      updatePlanUi();
      return;
    }

    var modeButton = closest(event.target, '[data-spark-plan-mode]');
    if (modeButton && root.contains(modeButton)) {
      event.preventDefault();
      var mode = modeButton.getAttribute('data-spark-plan-mode');
      if (mode === 'one') {
        selected = plans.one3 ? 'one3' : (plans.one ? 'one' : '3mo');
      } else if (selected === 'one' || selected === 'one3') {
        selected = plans['3mo'] ? '3mo' : '1mo';
      }
      updatePlanUi();
      return;
    }

    var checkoutButton = closest(event.target, '[data-spark-checkout]');
    if (checkoutButton && root.contains(checkoutButton)) {
      event.preventDefault();
      qualify();
    }
  });

  root.querySelectorAll('.spark-video-card').forEach(function (card) {
    var video = card.querySelector('video');
    var button = card.querySelector('button');
    if (!video || !button) return;
    video.autoplay = false;
    video.loop = false;
    video.muted = false;
    video.defaultMuted = false;
    video.playsInline = true;
    video.removeAttribute('autoplay');
    video.removeAttribute('loop');
    video.removeAttribute('muted');
    video.removeAttribute('controls');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    function sync() {
      card.classList.toggle('is-playing', !video.paused && !video.ended);
    }

    function toggle() {
      if (video.paused || video.ended) {
        root.querySelectorAll('.spark-video-card video').forEach(function (other) {
          if (other !== video) other.pause();
        });
        var attempt = video.play && video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(sync);
      } else {
        video.pause();
      }
      sync();
    }

    button.addEventListener('click', toggle);
    card.addEventListener('click', function (event) {
      if (event.target === button || button.contains(event.target)) return;
      toggle();
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('ended', sync);
    sync();
  });

  root.querySelectorAll('[data-spark-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-spark-gallery-track]');
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-spark-gallery-dot]'));
    if (!track || !dots.length) return;

    var ticking = false;
    function galleryIndex() {
      return Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))));
    }

    function syncGalleryDots() {
      var active = galleryIndex();
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === active);
        if (index === active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      ticking = false;
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncGalleryDots);
    }, { passive: true });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      });
    });

    syncGalleryDots();
  });

  var menuButton = root.querySelector('[data-spark-menu]');
  var mobileMenu = root.querySelector('[data-spark-mobile-menu]');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');
        menuButton.setAttribute('aria-expanded', 'false');
      });
    });
  }

  root.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.getElementById((link.getAttribute('href') || '').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  var sticky = root.querySelector('[data-spark-sticky]');
  var hero = root.querySelector('.spark-hero');
  var offer = root.querySelector('[data-spark-offer]');
  function updateSticky() {
    if (!sticky || !hero) return;
    var offerRect = offer ? offer.getBoundingClientRect() : null;
    var offerIsVisible = offerRect && offerRect.top < window.innerHeight * 0.88 && offerRect.bottom > 72;
    sticky.classList.toggle('is-visible', hero.getBoundingClientRect().bottom < 0 && !offerIsVisible);
  }
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  updateSticky();

  var trackingKeys = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'msclkid', 'fbclid', 'ttclid'];
  var params = new URLSearchParams(window.location.search);
  if (trackingKeys.some(function (key) { return params.has(key); })) {
    root.querySelectorAll('a[href^="/"],a[href^="' + window.location.origin + '"]').forEach(function (anchor) {
      try {
        var url = new URL(anchor.getAttribute('href'), window.location.origin);
        trackingKeys.forEach(function (key) {
          if (params.has(key) && !url.searchParams.has(key)) url.searchParams.set(key, params.get(key));
        });
        anchor.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (err) {}
    });
  }

  updatePlanUi();
})();
